import { Store } from 'vuex'
export default new Store({
  state: {
    selected: {},
  },
  mutations: {
    setSelected(state, value) {
      state.selected = value
    },
  },
})